export const unFormatCurrency = (value: string) => {
  if (!value) return 0;

  return Number(
    value
      .replace(/[^\d,\-.]/g, '')
      .replace(/,/g, '.')
      .replace(/\.(?=.*\.)/g, '')
  );
};

export const unFormatPercentage = (value: string) => {
  return Number(value.substring(0, value.length - 2).replace(/[\,\-() ]/g, '.')) / 100;
};

export const removeSpecialCharacters = (value: string) => {
  return value.replace(/[^a-zA-Z0-9]/g, '');
};

export const unFormatCnpj = (value: string) => {
  return value.replace(/\D/g, '');
};

export const unFormatUnit = (value: string, unit: string): number => {
  let cleanedValue = value.replace(` ${unit}`, '').trim();

  cleanedValue = cleanedValue.replace(/\./g, '');
  cleanedValue = cleanedValue.replace(/,/g, '.');

  return Number(cleanedValue);
};

export const unFormatUnknownUnit = (value: string): number => {
  return Number(value.split(' ')[0].replace(/\./g, '').replace(',', '.'));
};
